import { 
  AfterViewInit,
  Directive,
  DoCheck,
  EventEmitter,
  ElementRef,
  HostListener,
  Output,
  Renderer2,
  ViewContainerRef
} from '@angular/core';

@Directive({
  selector: '[appCustomTooltip]'
})
export class CustomTooltipDirective implements AfterViewInit, DoCheck {

  sidebarRef: any;
  showArrowTimeout: any;

  @Output() changeTooltipVisiblity: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() hideDropdowns: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly elementRef: ElementRef,
    private readonly viewRef: ViewContainerRef,
    private readonly renderer: Renderer2
  ) { }

  /**
   * listens to every mouseover (hover) event on the sidebar
   */
  @HostListener('mouseover', ['$event'])
  onMouseOver() {
    clearInterval(this.showArrowTimeout)
    this.showArrowTimeout = setTimeout(() => {
      this.toggleClassList(true)
    }, 200)
  }

   /**
   * listens to every mouseleave (hover) event on the sidebar
   * 
   * emits hideDropdowns event ( hides all the dropdowns in the side bar )
   */
  @HostListener('mouseleave', ['$event'])
  onMouseLeave() {
    this.hideDropdowns.emit(true)
    clearInterval(this.showArrowTimeout)
    this.toggleClassList(false)
  }

  ngDoCheck(): void {
    this.emitVisiblityValue();
  }

  ngAfterViewInit(): void {
    this.emitVisiblityValue();
  }

  /**
   * remove or add the drop-down-show class to the divs containing has-dropdown class
   * @param addClass boolean | decides to add or remove the class 
   * 
   * @usageNotes used to hide the arrow down icon from the side bar
   */
  toggleClassList(addClass: boolean): void {
    const dropdownMenuDivs = this.viewRef.element.nativeElement.querySelectorAll('div.has-dropdown');
    dropdownMenuDivs.forEach(node => {
      addClass ? this.renderer.addClass(node, 'drop-down-show'): this.renderer.removeClass(node, 'drop-down-show')
    });
  }

  /**
   * hides the tooltip when width of the sidebar is less than 250px
   */
  emitVisiblityValue(): void {
    this.sidebarRef = this.elementRef.nativeElement;
    if (this.sidebarRef.clientWidth < 250) {
      this.changeTooltipVisiblity.emit(true);
    } else {
      this.changeTooltipVisiblity.emit(false);
    }
  }

}
